<template>
	<span style="display: flex;" @click.stop.prevent="onClick">
		<span>
			<SvgRadioFilledChecked v-if="isChecked" :style="checkedStyle" />
			<SvgRadio v-if="!isChecked" style="color: #ccc;" />
		</span>

		<span v-if="$slots.default" style="padding-top: 3px; margin-left: 5px; cursor: pointer; user-select: none;">
			<slot />
		</span>
	</span>
</template>

<script setup lang="ts">
import { computed } from "vue"

import SvgRadio from "@/svg/customer/checkbox/radio.svg"
import SvgRadioFilledChecked from "@/svg/customer/checkbox/radio-filled-checked.svg"

const emit = defineEmits(['update:modelValue'])

// Props
const props = defineProps({
	modelValue: {
		type: [Boolean, String, Number],
		default: false,
	},

	checkedValue: {
		type: [Boolean, String, Number],
		default: ""
	},

	disabled: {
		type: [Boolean, String, Number],
		default: false
	},

	readonly: {
		type: [Boolean, String, Number],
		default: false
	},			
})

// Computeds
const isChecked = computed(() => props.modelValue == props.checkedValue)
const checkedStyle = computed(() => {
	return {
		color: "#65A752",
		opacity: props.disabled ? 0.5 : 1,
	}
})

// Methods
function onClick(){
	if(props.disabled || props.readonly) return;

	emit('update:modelValue', props.checkedValue)
}
</script>
